module.exports = __webpack_public_path__ + "img/personalized-storefront.455fbe67.png";